<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,8C12,8.14,11.969999999999999,8.27,11.92,8.39C11.92,8.39,11.92,8.39,11.92,8.39C11.92,8.39,8.92,15.38,8.92,15.38C8.92,15.38,8.92,15.38,8.92,15.38C8.92,15.38,8.92,15.38,8.92,15.38C8.92,15.38,8.92,15.38,8.92,15.38C8.77,15.75,8.41,16,8,16C7.59,16,7.23,15.75,7.08,15.39C7.08,15.39,7.08,15.39,7.08,15.39C7.08,15.39,7.08,15.39,7.08,15.39C7.08,15.39,7.08,15.39,7.08,15.39C7.08,15.39,4.08,8.4,4.08,8.4C4.08,8.4,4.08,8.4,4.08,8.4C4.03,8.27,4,8.14,4,8C4,7.86,4.03,7.73,4.08,7.61C4.08,7.61,4.08,7.61,4.08,7.61C4.08,7.61,7.08,0.62,7.08,0.62C7.08,0.62,7.08,0.62,7.08,0.62C7.08,0.62,7.08,0.62,7.08,0.62C7.08,0.62,7.08,0.62,7.08,0.62C7.23,0.25,7.59,0,8,0C8.41,0,8.77,0.25,8.92,0.61C8.92,0.61,8.92,0.61,8.92,0.61C8.92,0.61,8.92,0.61,8.92,0.61C8.92,0.61,8.92,0.61,8.92,0.61C8.92,0.61,11.92,7.6,11.92,7.6C11.92,7.6,11.92,7.6,11.92,7.6C11.969999999999999,7.73,12,7.86,12,8C12,8,12,8,12,8ZM8,3.54C8,3.54,6.09,8,6.09,8C6.09,8,9.91,8,9.91,8C9.91,8,8,3.54,8,3.54C8,3.54,8,3.54,8,3.54Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Compass',
} as DefineComponent
</script>
